<span class="holder">
  <i class="icon ic-companies" [hidden]="holder.$type !== 'CorporateHolderModel'"></i>
  <i class="icon ic-my-account" [hidden]="holder.$type !== 'IndividualHolderModel'"></i>
  <span>{{ holder.name }}</span>
</span>
